import { useCreateOrderUser } from "../../hooks/useCreateOrderUser"
import { OrderOnBehalfFlow } from "../../orderOnBehalf/OrderOnBehalfFlow"
import { UserType } from "../../../../../modules/login/loginTypes"
import { CreateOrderDialogMode, type SelectedMainUserState } from "../../createOrderTypes"

import { TakeawayOrderDialog } from "./TakeawayOrderDialog"

type TakeawayOrderHostProps = Readonly<{
    open: boolean
    onClose: () => void
}>

export function TakeawayOrderHost({ open, onClose }: TakeawayOrderHostProps) {
    const { onBehalf, setOnBehalf } = useCreateOrderUser({ mode: CreateOrderDialogMode.CREATE })

    const handleOnComplete = (id: number, name: string, companyId: number) => {
        setOnBehalf((prev) => ({ ...prev, show: false, userId: id, displayName: name, companyId }))
    }

    if (!open) return null

    if (onBehalf.show) {
        return (
            <OrderOnBehalfFlow
                userType={onBehalf.userType}
                onComplete={handleOnComplete}
                handleCloseParentDialog={onClose}
            />
        )
    }

    const onBehalfUser: SelectedMainUserState | undefined =
        onBehalf.userType === UserType.USER
            ? undefined
            : {
                  userId: onBehalf.userId,
                  displayName: onBehalf.displayName,
                  companyId: onBehalf.companyId,
                  userType: onBehalf.userType,
              }

    return <TakeawayOrderDialog open={open} onClose={onClose} onBehalfUser={onBehalfUser} />
}
